import { getDeviceInfo } from "helpers/utils";
import { getUserToken } from "../helpers/authHelper";
import api from "../api";


export async function FetchScreeningList(payload) {

  return await api({
    method: "get",
    params: payload,
    url: `${process.env.REACT_APP_API_URL}/admin/screening/screening-list`,
    headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "","X-lang_id": localStorage.getItem("lang_id") || "", },
  });
}
export async function RejectScreeningRecord(id) {
  console.log('faqsServices:24',id);
 return await api({
   method: "put",
   data: '',
   url: `${process.env.REACT_APP_API_URL}/admin//common/reject-application/${id}`,
   headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
 });
}

export async function updateRoundStatus(payload) {
  let device_info = await getDeviceInfo(navigator)
  if(payload.roundType=='Interview')
  {
    return await api({
      method: "post",
      data: { ...payload, device_info: device_info },
      url: `${process.env.REACT_APP_API_URL}/admin/screening/updateroundstatus`,
      headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
    });
  }
  else{
    return await api({
      method: "post",
      data: { ...payload, device_info: device_info },
      url: `${process.env.REACT_APP_API_URL}/admin/pending/updateroundstatus`,
      headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
    });
  }
 
}
